export const API_URL = import.meta.env.VITE_API_URL;
export const AUTH_URL = import.meta.env.VITE_AUTH_URL;
/** Vite build mode: "production" (npm run build), "staging" (build:staging), "development". */
export const APP_ENVIRONMENT = import.meta.env.MODE;
/** Browser Google Maps key for the Demos area map (SF-4651); optional, the map says when unset. */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
